import { css } from 'styled-components';
import { colors } from '../colors/colors';
import { LoaderTags } from './class-name-tags';
import { commonTheme } from './common-theme';
export const loaderLightTheme = {
    ...commonTheme,
    base: css `
    ${commonTheme.base}

    & .${LoaderTags.spinningBar} {
      stroke: ${colors.coolgrey300};
    }

    & .${LoaderTags.circle} {
      stroke: ${colors.ultramarine900};
    }
  `,
};
//# sourceMappingURL=light-theme.js.map